<template>
  <div class="Production-Plan-Item">
        <PageTitle
            imagem="bottles.png"
            main="Cadastro de Insumos"
            sub=""
        />
       <RegisterInputsEditor />
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import RegisterInputsEditor from "./registerInputsEditor";

export default {
  name: "registerInputs",
  components: { PageTitle ,RegisterInputsEditor},
  beforeDestroy(){
    this.$store.commit("setMapList", null)
  }
};
</script>



<style>




</style>